import hash from 'object-hash';

const OPTIONS = {
  respectType: false, // otherwise the hash would have a different value in ie11
};

const createCacheHash = (args) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- timeout param should not be part of args to compare against for caching purposes
  const { timeout, ...argsWithoutTimeout } = args;

  try {
    const body = JSON.parse(args.body);

    return hash({ ...argsWithoutTimeout, body }, OPTIONS);
  } catch (e) {
    return hash(argsWithoutTimeout, OPTIONS);
  }
};

export default createCacheHash;
